import React, { createContext, useContext, useEffect, useState } from 'react';
import { io } from 'socket.io-client';

const SocketContext = createContext();

export const useSocket = () => {
  const context = useContext(SocketContext);
  if (!context) {
    throw new Error('useSocket must be used within a SocketProvider');
  }
  return context;
};

export const SocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    // Temporarily disable socket connection for demo
    console.log('Socket connection disabled for demo purposes');

    // const newSocket = io(process.env.REACT_APP_SERVER_URL || 'http://localhost:5002');

    // newSocket.on('connect', () => {
    //   setConnected(true);
    //   console.log('Connected to server');
    // });

    // newSocket.on('disconnect', () => {
    //   setConnected(false);
    //   console.log('Disconnected from server');
    // });

    // setSocket(newSocket);

    // return () => newSocket.close();
  }, []);

  const value = {
    socket,
    connected
  };

  return (
    <SocketContext.Provider value={value}>
      {children}
    </SocketContext.Provider>
  );
};